import { FILTER as filter } from './filter';
import { POINTS_SUMMARY as pointsSummary } from './pointsSummary';

export const UI = {
  filter,
  pointsSummary
};
